// frontend/src/components/Reports/ServiceReport.jsx
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { reportService } from '../../services/api';
import LoadingSpinner from '../Common/LoadingSpinner';

export default function ServiceReport({ dateRange }) {
  const { data, isLoading } = useQuery({
    queryKey: ['service-report', dateRange],
    queryFn: () => reportService.getServiceReport(dateRange)
  });

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="p-6">
      <h3 className="text-lg font-semibold mb-4">Services Revenue Report</h3>
      
      {/* Service Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div className="bg-purple-50 p-4 rounded-lg">
          <p className="text-sm text-purple-600">Total Service Revenue</p>
          <p className="text-2xl font-bold text-purple-700">
            KES {data?.totalServiceRevenue?.toLocaleString() || 0}
          </p>
        </div>
        <div className="bg-blue-50 p-4 rounded-lg">
          <p className="text-sm text-blue-600">Service Transactions</p>
          <p className="text-2xl font-bold text-blue-700">
            {data?.totalServiceTransactions || 0}
          </p>
        </div>
        <div className="bg-green-50 p-4 rounded-lg">
          <p className="text-sm text-green-600">Average Service Value</p>
          <p className="text-2xl font-bold text-green-700">
            KES {data?.averageServiceValue?.toLocaleString() || 0}
          </p>
        </div>
      </div>

      {/* Services Breakdown Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left">Service Name</th>
              <th className="px-4 py-3 text-right">Quantity Sold</th>
              <th className="px-4 py-3 text-right">Unit Price</th>
              <th className="px-4 py-3 text-right">Total Revenue</th>
              <th className="px-4 py-3 text-right">VAT Collected</th>
            </tr>
          </thead>
          <tbody>
            {data?.services?.map(service => (
              <tr key={service.id} className="border-t hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div className="font-medium">{service.name}</div>
                  <div className="text-xs text-gray-500">{service.sku}</div>
                </td>
                <td className="px-4 py-3 text-right">{service.quantity_sold}</td>
                <td className="px-4 py-3 text-right">KES {service.unit_price?.toLocaleString()}</td>
                <td className="px-4 py-3 text-right font-semibold text-purple-600">
                  KES {service.total_revenue?.toLocaleString()}
                </td>
                <td className="px-4 py-3 text-right">KES {service.total_tax?.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data?.services?.length === 0 && (
          <div className="text-center py-8 text-gray-500">No service transactions found</div>
        )}
      </div>
    </div>
  );
}